import React, { useEffect, useState } from "react";
import style from "./users.module.scss";
import { withRouter, Link } from "react-router-dom";
import Button from "../Button/button"
import Searchbar from "../productSearchbar/productSearchbar"
import UsersCard from "./userCard/userCard";
import Modal from "../Modal/Modal";
import Input from "../input/input"
import Dropdown from "../Dropdown/SimpleDropDown/DropDown";
import toEnglishNumber from "../../helpers/actions/toEnglishNumber"
import Toast from "../Toast/Toast"
import { AddUser, DeactiveUser, DeleteUser, EditUser, GetPermissionList, GetUsers } from "../../actions/APIcalls"
import GradientToast from "../gradientToast/Toast"
import Skeleton from "./skeleton"

const addUserFields = ["name", "number", "password", "permission"]

const Users = (props) => {
    const [hasSkeleton, setHasSkeleton] = useState(false)
    const [offset, setOffset] = useState(0);
    const [addUser, setAddUser] = useState({
        open: false,
        name: "",
        number: "",
        permission: "",
        password: "",
        nameErr: "",
        numberErr: "",
        passwordErr: "",
        permissionErr: "",
        userCapacity: 1
    })

    const [editUser, setEditUser] = useState({
        open: false,
        id: "",
        name: "",
        number: "",
        password: "",
        permission: "",
        nameErr: "",
        numberErr: "",
        passwordErr: ""
    })
    const [deleteUser, setDeleteUser] = useState({ open: false, id: "", success: false })
    const [toast, setToast] = useState('')
    const [userList, setUserList] = useState([])
    const [permissionList, setPermissionList] = useState([])
    const [search, setSearch] = useState('');
    const [addUserPermissionDeniedShow, setAddUserPermissionDeniedShow] = useState(false)


    //lifeCycles********************************************************************************************
    useEffect(async () => {
        if (typeof props.location !== "undefined" && typeof props.location.search !== "undefined" && props.location.search !== "") {
            let url = new URLSearchParams(window.location.search);
            await setSearch(url.get("search"));
        }

    }, [props.user]);
    useEffect(() => {

        getUsers()
    }, [props.history.location.search])
    useEffect(() => {
        window.addEventListener('popstate', () => {
            setSearch("")
        })
        return () => window.removeEventListener('popstate', () => {
        })
    }, [])
    useEffect(() => {
        const onScroll = () => setOffset(window.pageYOffset);
        // clean up code
        window.removeEventListener('scroll', onScroll);
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);
    //functions*********************************************************************************************
    const validation = (type) => {
        switch (type) {
            case "addUser":
                let add = addUser;
                addUserFields.forEach(item => {
                    if (addUser[item]) {
                        add[item + "Err"] = ""
                        setAddUser({ ...add })
                    } else {
                        add[item + "Err"] = "تکمیل این فیلد الزامیست"
                        setAddUser({ ...add })
                    }
                })
                if (!addUser.nameErr && !addUser.passwordErr && !addUser.permissionErr && !addUser.numberErr) return true
                else return false

            case "editUser":
                let edit = editUser;
                addUserFields.forEach(item => {
                    if (editUser[item]) {
                        edit[item + "Err"] = ""
                        setEditUser({ ...edit })
                    } else {
                        edit[item + "Err"] = "تکمیل این فیلد الزامیست"
                        setEditUser({ ...edit })
                    }
                })
                if (!editUser.nameErr && !editUser.passwordErr && !editUser.permissionErr && !editUser.numberErr) return true
                else return false

            default:
                return true

        }
    }

    //get data**********************************************************************************************
    const getPermissionList = async () => {
        let res = await GetPermissionList()
        if (res && res.data) {
            let array = []
            if (res.data.permissionList.length == 0) {
                let add = addUser
                let edit = editUser
                add.permissionErr = "ابتدا سطح دسترسی تعریف کنید."
                edit.permissionErr = "ابتدا سطح دسترسی تعریف کنید."
                setAddUser({ ...add })
                setEditUser({ ...edit })

            }
            res.data.permissionList.forEach(item => {
                let obj = {
                    name: item.title,
                    id: item._id,
                    checked: false
                }
                array.push(obj)
            });

            setPermissionList([...array])
        }
    }
    const getUsers = async () => {
        setHasSkeleton(true)
        let res;
        let add = addUser
        res = await GetUsers({ search: (typeof props.history.location.state !== "undefined" ? props.history.location.state.search : "") });
        if (typeof res !== "undefined" && typeof res.data !== "undefined") {
            let tempArray = res.data.users
            if (typeof props.user !== "undefined") {
                let index = res.data.users.findIndex(item => item.phone === props.user.phone)
                if (index > -1 && index !== 0) {
                    tempArray.splice(index, 1);
                    tempArray[1] = props.user
                }
                add.userCapacity = res.data.userCount
                // add.canAddUser = res.data.can_add_user
                add.canAddUser = true
                setAddUser({ ...add })
                setUserList([...tempArray])
            }
        }
        setHasSkeleton(false)
    }
    //handelers*********************************************************************************************
    const searchHandler = (val) => {
        setSearch(val);
        props.history.push(
            '/users?search=' + val,
            { search: val }
        );
    }
    const toggleHandlerParent = async (id, active) => {
        let params = { adminId: id, active: active }
        let res = await DeactiveUser(params)
        if (typeof res !== "undefined" && typeof res.data !== "undefined") {
            getUsers()
        } else if (typeof res !== "undefined" && typeof res.response !== "undefined") {
            setToast(res.response.data.error)
        }
    }

    const postUserData = async (type) => {
        switch (type) {
            case "add": {
                let params = {
                    name: addUser.name,
                    phone: toEnglishNumber(addUser.number),
                    permission: addUser.permission,
                    password: (addUser.password)
                }
                let res = await AddUser(params)
                // console.log(res, "add");
                if (res && res.data && res.data.success) {
                    setAddUser({
                        open: false,
                        name: "",
                        number: "",
                        permission: "",
                        password: "",
                        nameErr: "",
                        numberErr: "",
                        passwordErr: "",
                        permissionErr: ""
                    })
                    setToast('')
                    getUsers()
                } else if (typeof res.response !== "undefined") {

                    setToast(res.response.data.error)
                }
            }
                break;
            case "edit": {
                let params = {
                    name: editUser.name,
                    phone: toEnglishNumber(editUser.number),
                    permission: editUser.permission,
                    password: (editUser.password) && (editUser.password),
                    adminId: editUser.id
                }
                let res = await EditUser(params)
                if (typeof res !== "undefined" && typeof res.data !== "undefined") {
                    setEditUser({ open: false })
                    setToast('')
                    getUsers()
                } else if (typeof res !== "undefined" && typeof res.response !== "undefined") {
                    setToast(res.response.data.error)
                }
            }
                break;
            case "delete": {
                let res = await DeleteUser({ adminId: deleteUser.id });
                if (typeof res !== "undefined" && typeof res.data !== "undefined") {
                    let deleteu = deleteUser
                    deleteu.success = true;
                    setDeleteUser({ ...deleteu })
                    getUsers()
                } else if (typeof res !== "undefined" && typeof res.response !== "undefined") {
                    setToast(res.response.data.error)
                }
            }
                break;
            default:
                break;
        }
    }
    const dropdownHandler = (tag, id) => {
        if (tag === "edit") {
            if (typeof props.user !== "undefined" && props.user.permission.userManagement.includes("Edit")) {
                setAddUser({ open: false })
                setDeleteUser({ open: false })
                let res = userList.find(item => item._id === id);
                if (typeof res !== "undefined") {
                    getPermissionList()
                    let edit = editUser;
                    edit.name = res.name;
                    edit.number = res.phone;
                    edit.permission = typeof res.permission !== "undefined" && res.permission._id;
                    edit.password = res.password
                    edit.open = true;
                    edit.id = id;
                    setEditUser({ ...edit })
                }
            }
        } else {
            if (typeof props.user !== "undefined" && props.user.permission.userManagement.includes("Delete")) {
                setAddUser({ open: false })
                setEditUser({ opne: false })
                setDeleteUser({ open: "true", id: id, success: false })
            }
        }
    }
    const onchangeHandler = (tag, value, secondTag) => {
        let add = addUser;
        let edit = editUser
        switch (tag) {
            case "addName": {
                add.name = value.target.value;
                setAddUser({ ...add })
                break;
            }
            case "addNumber": {
                let reg = new RegExp(/^\d+$/);
                if (reg.test(toEnglishNumber(value.target.value)) && value.target.value.length < 12) {
                    add.number = toEnglishNumber(value.target.value);
                } else if (value.target.value === "") {
                    add.number = ""
                }
                setAddUser({ ...add })
                break;
            }
            case "addPassword": {
                add.password = value.target.value;
                setAddUser({ ...add })
                break;
            }
            case "editName": {
                edit.name = value.target.value;
                setEditUser({ ...edit })
                break;
            }
            case "editNumber": {
                edit.number = value.target.value;
                setEditUser({ ...edit })
                break;
            }

            default:
                break;
        }

    }

    const onBlureHandler = (tag) => {
        let add = addUser;
        let edit = editUser;
        switch (tag) {
            case "addNumber": {
                let reg = new RegExp("^(09)[0-9]{9}$");
                if (addUser.number && addUser.number.length > 0 && !reg.test(toEnglishNumber(addUser.number))) {
                    add.numberErr = "فرمت شماره صحیح نیست!"
                } else if (addUser.number.length === 0) {
                    add.numberErr = "تکمیل این فیلد الزامی است!"
                } else {
                    add.numberErr = ""
                }
                setAddUser({ ...add })
                break;
            }
            case "editNumber": {
                let reg = new RegExp("^(09)[0-9]{9}$");
                if (editUser.number.length > 0 && !reg.test(toEnglishNumber(editUser.number))) {
                    edit.numberErr = "فرمت شماره صحیح نیست!"
                } else if (editUser.number.length === 0) {
                    edit.numberErr = "تکمیل این فیلد الزامی است!"
                } else {
                    edit.numberErr = ""
                }
                setEditUser({ ...edit })
                break;
            }
            case "editName": {
                if (editUser.name.length === 0) {
                    edit.nameErr = "تکمیل این فیلد الزامی است!"
                } else {
                    edit.nameErr = ""
                }
                setEditUser({ ...edit })
                break;
            }

            case "editPassword": {
                if (editUser.password.length === 0) {
                    edit.passwordErr = "تکمیل این فیلد الزامی است!"
                } else {
                    edit.passwordErr = ""
                }
                setEditUser({ ...edit })
                break;
            }


            default:
                break;
        }

    }
    const handleSelect = (tag, item) => {
        console.log(tag, item);
        if (tag === "addUser") {
            let modal = addUser
            modal.permission = item.id;
            setAddUser({ ...modal })
        }
        if (tag === "editUser") {
            let modal = editUser
            modal.permission = item.id;
            setEditUser({ ...modal })
        }
    }
    const cancelModal = (tag, get, set) => {
        console.log(tag);
        if (tag == "addUser") {
            setAddUser({
                open: false,
                name: "",
                number: "",
                permission: "",
                password: "",
                nameErr: "",
                numberErr: "",
                passwordErr: "",
                permissionErr: "",
                canAddUser: addUser.canAddUser
            })
        } else if (tag == "editUser") {
            setEditUser({
                open: false,
                name: "",
                number: "",
                permission: "",
                password: "",
                nameErr: "",
                numberErr: "",
                passwordErr: "",
                permissionErr: ""
            })
        } else {
            let modal = get;
            modal.id = "";
            modal.channelId = "";
            modal.open = false;
            modal.success = false;
            set({ ...modal });
        }

    }


    //JSX*****************************************************************************************************************

    const ButtonPackRenderer = (maintag, canceltag, mainlabel, mainaction, get, set) => {
        return (
            <div className={style.buttonPack}>
                < Button
                    disabled={false}
                    tag={canceltag}
                    type="outline"
                    label="انصراف"
                    onclick={() => {
                        cancelModal(maintag, get, set);
                        setToast('')
                    }} />
                <div className={style.splitter}></div>
                < Button
                    disabled={false}
                    tag={maintag}
                    type="solid"
                    label={mainlabel}
                    onclick={() => {
                        validation(maintag) && mainaction()
                    }}
                />
            </div>
        )
    }

    const addEditUserRenderer = (data) => {

        if (typeof data == "undefined") {
            return (
                <div className={style.modalContent}>
                    <div className={style.inputWrapper}>
                        <Input
                            label="نام و نام خانوادگی"
                            placeholder="نام و نام خانوادگی"
                            tag="addName"
                            value={addUser.name}
                            error={addUser.nameErr}
                            tooltip={""}
                            onchange={onchangeHandler}
                            onblur={onBlureHandler} />
                    </div>
                    <div className={style.inputWrapper}>
                        <Input
                            label="شماره تلفن همراه"
                            placeholder="شماره تلفن همراه"
                            tag="addNumber"
                            value={addUser.number}
                            error={addUser.numberErr}
                            tooltip={""}
                            onchange={onchangeHandler}
                            onblur={onBlureHandler} />
                    </div>
                    <div className={style.privillageWrapper}>
                        <Dropdown
                            tag='addUser'
                            label='سطح دسترسی'
                            placeHolder={addUser.permission && permissionList.length > 0 && permissionList.find(item => item.id == addUser.permission).name}
                            placeHolderStyle={addUser.permission && permissionList.length > 0 && permissionList.find(item => item.id == addUser.permission)}
                            dropdownList={permissionList}
                            hasSearchBox={false}
                            hasCheckbox={false}
                            handleSelect={handleSelect}
                            handleSearch={() => {
                            }}
                            onblure={() => {
                            }}
                            deleteSelectedItems={() => {
                                let add = addUser;
                                add.permission = "";
                                setAddUser({ ...add })
                            }}
                            errorMessage={addUser.permissionErr} />
                    </div>
                    <div className={style.inputWrapper}>
                        <Input
                            label="رمز عبور"
                            placeholder="رمز عبور"
                            tag="addPassword"
                            value={addUser.password}
                            type="password"
                            error={addUser.passwordErr}
                            tooltip={""}
                            onchange={onchangeHandler}
                            onblur={onBlureHandler} />
                    </div>
                    {ButtonPackRenderer("addUser", "cancelUser", "ایجاد", () => postUserData("add"), addUser, setAddUser)}
                </div>
            )
        } else {
            return (
                <div className={style.modalContent}>
                    <div className={style.inputWrapper}>
                        <Input
                            label="نام و نام خانوادگی"
                            placeholder="نام و نام خانوادگی"
                            tag="editName"
                            value={editUser.name}
                            error={editUser.nameErr}
                            tooltip={""}
                            onchange={onchangeHandler}
                            onblur={onBlureHandler} />
                    </div>
                    <div className={style.inputWrapper}>

                        <Input
                            label="شماره تلفن همراه"
                            placeholder="شماره تلفن همراه"
                            tag="editNumber"
                            value={editUser.number}
                            error={editUser.numberErr}
                            tooltip={""}
                            disabled={true}
                            onchange={onchangeHandler}
                            onblur={onBlureHandler} />

                    </div>
                    <div className={style.privillageWrapper}>
                        <Dropdown
                            tag='editUser'
                            label='سطح دسترسی'
                            placeHolder={editUser.permission && permissionList.length > 0 && permissionList.find(item => item.id == editUser.permission).name}
                            placeHolderStyle={editUser.permission && permissionList.length > 0 && permissionList.find(item => item.id == editUser.permission)}
                            dropdownList={permissionList}
                            hasSearchBox={false}
                            hasCheckbox={false}
                            handleSelect={handleSelect}
                            handleSearch={() => {
                            }}
                            onblure={() => {
                            }}
                            deleteSelectedItems={() => {
                                let add = addUser;
                                add.permission = "";
                                setAddUser({ ...add })
                            }}
                            errorMessage={addUser.permissionErr} />
                    </div>
                    {ButtonPackRenderer("editUser", "cancelUser", "ویرایش", () => postUserData("edit"), editUser, setEditUser)}
                </div>
            )
        }
    }
    const modalActivator = (modalName) => {
        switch (modalName) {
            case "addUser":
                if (addUser.canAddUser) {

                    if (typeof props.user !== "undefined" && props.user.permission.userManagement.includes("Add")) {
                        getPermissionList()
                        {
                            let add = addUser;
                            add.open = true;
                            setAddUser({ ...add });
                        }
                    }
                    setAddUserPermissionDeniedShow(false)

                } else {
                    setAddUserPermissionDeniedShow(true)
                }
                break

            default:
                break;
        }
    }

    if (hasSkeleton) {
        return <Skeleton />
    } else {
        return (
            <div className={style.wrapper}>
                {
                    props.user.expiredAccount &&
                    <div className={style.gradientWrapper}>
                        <GradientToast tag="test" value={true}>
                            <>
                                <p className={style.expiredTitle}>شارژ کیف پول شما تمام شده‌است.</p>
                                <p className={style.expiredText}>برای فعال‌سازی مجدد ربات، کیف پول خود را شارژ کنید.</p>
                                <Link className={style.expiredLink} to={'/chargewallet'}>ورود به صفحه‌ی  شارژ کیف پول  </Link>
                            </>
                        </GradientToast>
                    </div>
                }
                <Toast
                    tag='Toast_1'
                    text={toast}
                    value={toast}
                    parentClose={() => setToast('')}
                />

                <Modal
                    tag="addUserPermissionDenied"
                    value={addUserPermissionDeniedShow}
                    title=""
                    parentClose={() => {
                        setAddUserPermissionDeniedShow(false)
                    }}
                >
                    <div className={style.contentWrapper}>
                        <div className={style.addUserPermissionDenied}>
                            <div className={style.addUserPermissionDeniedIcon}>M</div>
                            <p>.امکان ایجاد کاربر جدید برای این حساب کاربری وجود ندارد</p>
                            < Button
                                tag="confirm"
                                type="solid"
                                label="تایید"
                                onclick={() => setAddUserPermissionDeniedShow(false)}
                            />
                        </div>

                    </div>
                </Modal>
                <Modal
                    tag="newUser"
                    value={addUser.open ? true : false}
                    title="کاربر جدید"
                    parentClose={() => {
                        setAddUser({ open: false, password: "" });
                        setToast('')
                    }}>
                    {addEditUserRenderer()}
                </Modal>
                <Modal
                    tag="deleteUser"
                    value={deleteUser.open ? true : false}
                    title="حذف کاربران            "
                    parentClose={() => {
                        setDeleteUser({ open: false });
                        setToast('')
                    }}>
                    <div className={style.modalContent}>
                        {deleteUser.success ?
                            <div>
                                <p className={style.deleteText}>کاربر مورد نظر با موفقیت حذف شد.</p>
                                <Button type="solid" label='تایید' onclick={() => {
                                    setDeleteUser({ open: false })
                                }} />
                            </div>
                            : <div>
                                <p className={style.deleteText}>
                                    آیا از حذف
                                    {" "}{deleteUser.id && userList.find(item => item._id === deleteUser.id).name} {" "}
                                    اطمینان دارید؟</p>
                                {ButtonPackRenderer("deleteUser", "cancelDeleteUser", "حذف", () => {
                                    postUserData("delete")
                                }, deleteUser, setDeleteUser, true)}
                            </div>}
                    </div>
                </Modal>

                <Modal
                    tag="editUser"
                    value={editUser.open ? true : false}
                    title="ویرایش کاربران"
                    parentClose={() => {
                        setEditUser({ open: false });
                        setToast('')
                    }}>
                    {addEditUserRenderer(userList.find(item => item._id === editUser.id))}
                </Modal>

                <div className={style.header}>
                    <h1>لیست کاربران</h1>
                    <div className={style.buttonsWrapper}>
                        <div className={style.addUser}>
                            <Button label="کاربر جدید" type="solid" tag="addUser" disabled={false}
                                onclick={modalActivator} />
                        </div>
                    </div>
                </div>

                <div className={style.searchbarWrapper}>
                    <Searchbar
                        placeholder="نام و نام خانوادگی یا شماره موبایل"
                        searchValue={searchHandler}
                        value={search}
                    />
                </div>
                {/* New User List */}
                <div className={style.mainWrapper}>
                    {userList && userList.length > 0 ?
                        <div>
                            <div className={style.hiddenListShadow}></div>
                            <div className={style.logListWrapper}>
                                <div className={offset > 250 ? style.listHeaderFixed : style.listHeader}>
                                    <div className={style.listHeaderItem24}></div>
                                    <div className={style.listHeaderItem215}>نام و نام‌خانوادگی</div>
                                    <div className={style.listHeaderItem48}>وضعیت</div>
                                    <div className={style.listHeaderItem100}>شماره تلفن</div>
                                    <div className={style.listHeaderItem88}>سطح دسترسی</div>
                                    <div className={style.listHeaderItem113}></div>
                                </div>
                                <div className={offset > 250 ? style.hiddenListHeader : ''}></div>
                                <div className={style.channelCardsWrapper}>
                                    {userList.map((user, index) => <div className={style.listWrapper} key={index}>
                                        <UsersCard
                                            toggleHandlerParent={toggleHandlerParent}
                                            data={user}
                                            dropdown={dropdownHandler} />
                                    </div>)}
                                </div>
                            </div>
                        </div>
                        :
                        <div className={style.empty}>
                            {search ?
                                <React.Fragment>
                                    <div className={style.icon}>
                                        O
                                    </div>
                                    <p>.کاربر با چنین مشخصاتی یافت نشد</p>
                                </React.Fragment>
                                : <div className={style.emptyList}>
                                    <div className={style.icon}>
                                        M
                                    </div>
                                    <p>.کاربر عزیز، در حال حاضر شما هیچ کاربری در ربات موبیشا ندارید</p>
                                    <div className={style.buttonsWrapper}>
                                        <div className={style.addUser}>
                                            <Button label="کاربر جدید" type="solid" n1="addUser" disabled={false}
                                                onclick={modalActivator} tag="addUser" />
                                        </div>
                                    </div>
                                </div>}
                        </div>
                    }
                </div>
                {/* New User List */}
            </div>
        )
    }
}

export default withRouter(Users);
